import { Grid, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { IExtensionConfig } from "../../models/extensions";
import { useExtensionConfigs } from "../../hooks/useExtensionConfigs";
import { Extension } from "../../models/intalled-extensions";

const RefundsBeneficiaryForm = ({ name }: { name: string }) => {
  const [refundDescription, setRefundDescription] =
    useState<IExtensionConfig>();

  const { fetchExtensionConfig } = useExtensionConfigs();
  const fetchExtensions = useCallback(async () => {
    const configRefundDescription = await fetchExtensionConfig(
      Extension.REFUND,
      "RefundDescription"
    );
    setRefundDescription(configRefundDescription);
  }, [fetchExtensionConfig]);

  useEffect(() => {
    fetchExtensions();
  }, [fetchExtensions]);

  return (
    <>
      <Grid
        mt={1}
        mb={1}
        item
        xs={12}
        sm={12}
        display={"flex"}
        flexDirection={"row"}
        gap={0.5}
      >
        {refundDescription && refundDescription.value !== "" && (
          <Typography variant="subtitle1">{refundDescription.value}</Typography>
        )}
      </Grid>
      <Grid
        mt={1}
        mb={1}
        item
        xs={12}
        sm={6}
        display={"flex"}
        flexDirection={"row"}
        gap={0.5}
      >
        <Typography
          variant="subtitle1"
          sx={(theme) => ({
            color:
              theme.palette.mode === "light"
                ? theme.palette.grey[800]
                : theme.palette.grey[400],
          })}
        >
          Nome:
        </Typography>
        <Typography variant="subtitle1">{name}</Typography>
      </Grid>
    </>
  );
};

export default RefundsBeneficiaryForm;
